export enum StatusEventSignalColumnKind {
  CODE = 'code',
  TYPE = 'type',
  DESCRIPTION = 'description',
  LANGUAGE = 'language',
  OTHER = 'other'
}